import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetScreenshotsResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: (data: GetScreenshotsResponse) => void
  children?: (data: GetScreenshotsResponse) => ReactElement | undefined
}

const GetAiRunScreenshotsRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}/screenshots`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiRunScreenshotsRequest
